module.exports = [
  {
    url: '/common/enum/status',
    type: 'get',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: {
          '-1': '全部',
          0: '暂存',
          1: '审核中',
          2: '已通过',
          3: '未通过（驳回）',
          4: '自主撤销',
        },
      }
    },
  },
  {
    url: '/common/enum/documentType',
    type: 'get',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: {
          1: '第二代居民身份证',
          2: '港澳居民居住证',
          3: '外国人永久居留证',
          4: '港澳居民来往内地通行证',
          5: '台湾居民来往大陆通行证',
          6: '护照',
        },
      }
    },
  },
  {
    url: '/common/enum/driverType',
    type: 'get',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: {
          1: '驾驶员',
          2: '副驾驶员',
          3: '乘客',
        },
      }
    },
  },
  {
    url: '/common/enum/areaType',
    type: 'get',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: {
          1: '石化区',
          2: '惠州港',
          3: '石化区和惠州港',
        },
      }
    },
  },
  {
    url: '/common/enum/carVisitType',
    type: 'get',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: {
          1: '施工',
          2: '维修',
          3: '临时',
          4: '业主',
        },
      }
    },
  },
  {
    url: '/notice/statusEnum',
    type: 'get',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: ["暂存", "启用", "停用"],
      }
    },
  },
  {
    url: '/notice/typeEnum',
    type: 'get',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: {1: "通知公告", 2: "注意事项"},
      }
    },
  },
  {
    url: '/common/enum/plateColorType',
    type: 'get',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: [
          '黄色',
          '蓝色',
          '绿牌',
          '新能源绿',
          '新能源黄绿',
          '白牌',
          '黑色',
        ],
      }
    },
  },
  {
    url: '/common/enum/personVisitType',
    type: 'get',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: {
          1: '业主',
          2: '服务商',
          3: '建设单位',
          4: '临时来访',
        },
      }
    },
  },
  {
    url: '/common/enum/delayedType',
    type: 'get',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: {
          '-1': '全部',
          0: '否',
          1: '是',
        },
      }
    },
  },
  {
    url: '/common/enum/blackWhiteListType',
    type: 'get',
    response() {
      return {
        success: true,
        code: 1000,
        msg: '操作成功',
        data: {
          '-1': '全部',
          1: '黑名单',
          2: '白名单',
        },
      }
    },
  },
]
